export default "__VITE_ASSET__2FW6y7HK__"